import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import "../../css/account.css";

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

const ForgotPasswordPage = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');

    const handleSubmit = (event) => {
        event.preventDefault();
        if (!email) {
            setMessage('Vui lòng nhập email');
            setMessageType('error');
            return;
        }
        setLoading(true);
        setMessage('');

        fetch(`${API_BASE}/forgot-password`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email }),
        })
            .then((response) => response.json())
            .then((result) => {
                if (!result.success) {
                    throw new Error(result.message || 'Gửi yêu cầu thất bại');
                }
                setMessage('Nếu email tồn tại, chúng tôi đã gửi hướng dẫn đặt lại mật khẩu.');
                setMessageType('success');
            })
            .catch((err) => {
                setMessage(err.message || 'Không thể gửi yêu cầu');
                setMessageType('error');
            })
            .finally(() => setLoading(false));
    };

    return (
        <div className="tamcare-auth-page">
            <Link to="/login" className="tamcare-back-home">
                <i className="fa-solid fa-arrow-left"></i> Quay lại đăng nhập
            </Link>
            <div className="tamcare-auth-card tamcare-auth-card--login">
                <div className="tamcare-auth-logo">
                    <i className="fa-solid fa-key"></i>
                </div>

                <div className="tamcare-auth-card__header tamcare-auth-card__header--center">
                    <h2>Quên mật khẩu</h2>
                    <p>Nhập email để nhận hướng dẫn đặt lại mật khẩu</p>
                </div>

                {message && (
                    <div className={`tamcare-alert ${messageType === 'success' ? 'tamcare-alert--success' : 'tamcare-alert--error'}`} style={{ marginBottom: 16 }}>
                        {message}
                    </div>
                )}

                <form className="tamcare-auth-form" onSubmit={handleSubmit} method="POST">
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <div className="tamcare-input-wrap">
                            <i className="fa-regular fa-envelope"></i>
                            <input
                                id="email"
                                type="email"
                                name="email"
                                placeholder="email@example.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>
                    </div>

                    <button type="submit" className="tamcare-auth-btn" disabled={loading}>
                        {loading ? "Đang xử lý..." : "Gửi yêu cầu"}
                        <i className="fa-solid fa-paper-plane"></i>
                    </button>
                </form>

                <div className="tamcare-auth-footer tamcare-auth-footer--center">
                    <span>Đã nhớ mật khẩu?</span>
                    <Link to="/login">Đăng nhập</Link>
                </div>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;
